import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EluxIcon } from '@elxjs/ui'
import { ToastService } from './toast.service'
import { Toast, ToastType } from './toast.model'

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, EluxIcon],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent {
  toasts: Toast[] = []

  constructor(private toastService: ToastService) {
    this.toastService.toastChanges.subscribe((t) => {
      this.toasts = t
    })
  }

  close(id: string) {
    this.toastService.remove(id)
  }

  getToastIcon(type: ToastType): string {
    if (type === 'success') return 'Check_Tick.svg'
    if (type === 'error' || type === 'warning') return 'Warning.svg'
    return 'Info.svg'
  }

  getToastColor(type: ToastType): string {
    if (type === 'success') return '#0C5F29'
    if (type === 'error') return '#9C231C'
    if (type === 'warning') return '#8A4C00'
    return '#093BAE'
  }
}
